import { LineChart as MantineLineChart } from '@mantine/charts'
import { useMediaQuery } from '@mantine/hooks'
import { FULL_MONTH } from '../months'

type LineChartProps = {
  data: Array<{ label: string; value: number | null | undefined }>
  valueLabel: string
  formatter?: (value: number | null | undefined) => string
}

export default function LineChart(props: LineChartProps) {
  const isDesktop = useMediaQuery('(min-width: 800px)')
  const data = props.data.map(({ label, value }) => ({
    [props.valueLabel]: value,
    label,
  }))
  return (
    <MantineLineChart
      styles={{
        tooltip: {
          backgroundColor: 'light-dark(white, var(--mantine-color-gray-9)',
        },
      }}
      h="100%"
      w="100%"
      data={data}
      dataKey="label"
      series={[{ name: props.valueLabel, color: '#0B6B7B' }]}
      curveType="linear"
      connectNulls={false}
      dotProps={{ r: 4 }}
      valueFormatter={
        props.formatter ? props.formatter : (value) => value.toFixed(1)
      }
      xAxisProps={{
        tickFormatter: (label: string) => (isDesktop ? label : label[0]),
      }}
      tooltipProps={{
        labelFormatter: (label: string) => FULL_MONTH[label] || label,
      }}
    />
  )
}
